import React, { useState, useEffect } from "react";
import "./Catalogue.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Catalogue() {
  const [catalogues, setCatalogues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }).format(date);
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes || isNaN(bytes)) return 'N/A';
    const megabytes = (bytes / 1024 / 1024).toFixed(2);
    return `${megabytes} MB`;
  };

  useEffect(() => {
    const fetchCatalogues = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Catalogues`);
        if (!response.ok) {
          throw new Error("Failed to fetch catalogues");
        }
        const data = await response.json();
        setCatalogues(data);
      } catch (err) {
        setError("Failed to load catalogues. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCatalogues();
  }, []);

  return (
    <div className="catalogue-container">
      <div className="catalogue-background-gradient catalogue-gradient-1"></div>
      <div className="catalogue-background-gradient catalogue-gradient-2"></div>

      <div className="catalogue-content-wrapper">
        {/* Header Section */}
        <section className="catalogue-header-section">
          <h1 className="catalogue-heading">Our Product Catalogues</h1>
          <p className="catalogue-description">
            We offer a diverse range of products/ services designed to meet the
            highest industry standards. Browse our catalogue to find the best
            solutions for your business. For inquiries, feel free to contact us
            today!
          </p>
        </section>

        {loading && (
          <div className="w3-center">
            <p>Loading catalogues...</p>
          </div>
        )}

        {error && (
          <div className="w3-center" style={{ color: "red" }}>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && catalogues.length === 0 && (
          <div className="w3-center">
            <p>
              No catalogues are available at the moment. Please check back
              later.
            </p>
          </div>
        )}

        {!loading && !error && catalogues.length > 0 && (
          <section className="catalogue-grid">
            {catalogues.map((catalogue) => (
              <div className="catalogue-card" key={catalogue.id}>
                <div className="catalogue-card-image-container">
                  <img
                    className="catalogue-card-image"
                    src="./catalog-edited4.jpg"
                    alt={catalogue.name}
                  />
                  <div className="catalogue-card-overlay"></div>
                </div>

                {/* Catalogue Card Section */}
                <div className="catalogue-card-content">
                  <h3 className="catalogue-card-title">{catalogue.name}</h3>

                  <div className="catalogue-card-meta">
                    <div className="catalogue-card-meta-item">
                      <span className="catalogue-card-meta-label">Updated</span>
                      <span className="catalogue-card-meta-value">
                        <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: '5px', fontSize: '12px' }} />
                        {formatDate(catalogue.uploadDate)}
                      </span>
                    </div>
                    <div className="catalogue-card-meta-item">
                      <span className="catalogue-card-meta-label">File Size</span>
                      <span className="catalogue-card-meta-value">
                        <FontAwesomeIcon icon={faLayerGroup} style={{ marginRight: '5px', fontSize: '12px' }} />
                        {formatFileSize(catalogue.fileSize)}
                      </span>
                    </div>
                  </div>

                  <p className="catalogue-card-description">
                    {catalogue.description || 'Download our latest product catalogue for detailed specifications and pricing information.'}
                  </p>
                  <a 
                    href={`${catalogue.downloadUrl}`} 
                    className="catalogue-download-button-link"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <button className="catalogue-download-button">
                      <span className="catalogue-download-icon">
                        <i className="fa fa-download"></i>
                      </span>
                      Download
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </section>
        )}
      </div>
    </div>
  );
}

export default Catalogue;